import type {NodeEnvironment} from '#types/environment.js';

export const getCurrentEnv = (): NodeEnvironment => {
  if (typeof process !== 'undefined' && process.env.NODE_ENV) {
    return process.env.NODE_ENV === 'production' ? 'production' : 'development';
  }

  return 'development';
};
